import { secondaryColor } from './status/secondary';
export const secondary = (mode)=>{
    const color = secondaryColor(mode);
    return {
        ...color,
        // Use the high/low contrast versions instead. This is meant to backfill the MUI tokens.
        light: mode === 'light' ? color.lowContrast : color.highContrast,
        dark: mode === 'light' ? color.highContrast : color.lowContrast
    };
};

//# sourceMappingURL=secondary.js.map